export default __webpack_public_path__ + "assets/images/ac3c1db7baa46b1a256698ae38d138b7.svg";